<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAssetBulkUpload"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-auto"
      >
        <div
          class="fixed center-h-v bg-white h-5/6 rounded-md overflow-y-auto shadow-2xl sm:w-1/2 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <transition name="fade" v-if="create_error || uploadSucess">
            <p
              class="p-3"
              :class="{
                'text-yellow-500': create_error,
                'text-green-500': create_success,
              }"
            >
              {{ create_error ? create_error : create_success }}
            </p>
          </transition>

          <div
            class="flex justify-between items-center border-b-1.5 p-3 sticky top-0 bg-white"
          >
            <p class="text-base">Assets Bulk Upload</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <form
            @submit.prevent="create"
            class="p-4 flex flex-col bg-gray-100 sticky top-10 h-auto"
          >
            <div class="text-sm flex flex-col w-full">
              <input
                required
                type="file"
                ref="ExcelFile"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="onExcelFileChange"
                class="py-1 text-sm"
              />
            </div>
            <div class="py-3">
              <p v-if="RecordsFound > 0" class="text-sm font-medium">
                {{ RecordsFound }} Records found
              </p>
            </div>
            <button
              v-if="!beganUploading"
              type="submit"
              class="bg-primary rounded-full w-max p-2 text-xs text-white"
            >
              Begin Bulk Upload
            </button>
            <div v-if="uploading" class="flex items-center gap-2 font-medium">
              <loader />
              <p>Uploading please wait...</p>
            </div>
            <p v-if="isDoneUploading" class="text-sm font-medium">
              Finished uploading check the results below
            </p>
          </form>

          <div class="p-2 w-full">
            <div class="overflow-x-auto">
              <table
                v-if="isDoneUploading"
                class="table-auto w-full text-left text-xs"
              >
                <thead class="sticky top-0 bg-gray-100">
                  <tr
                    class="border border-0.5"
                    style="font-size: 0.6rem !important"
                  >
                    <th class="p-3"></th>
                    <th class="p-3">#</th>
                    <th class="p-3">Unique Number</th>
                    <th class="p-3">Serial Number</th>
                    <th class="p-3">Asset Brand</th>
                    <th class="p-3">Asset Model</th>
                    <th class="p-3">Asset Type</th>
                    <th class="p-3">Asset Status</th>
                    <th class="p-3">Asset Condition</th>
                    <th class="p-3">Assigned To</th>
                    <th class="p-3">Name</th>
                    <th class="p-3">Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(result, index) in DataToUpload"
                    :key="index"
                    class="border border-0.5"
                  >
                    <td class="p-1">
                      <img
                        class="h-5 object-contain"
                        :src="create_success ? successImage : errorImage"
                      />
                    </td>
                    <td class="p-3">{{ index + 1 }}</td>
                    <td class="p-3">{{ result.UniqueNumber }}</td>
                    <td class="p-3">{{ result.SerialNumber }}</td>
                    <td class="p-3">{{ result.Brand }}</td>
                    <td class="p-3">{{ result.Model }}</td>
                    <td class="p-3">{{ result.Type }}</td>
                    <td class="p-3">{{ result.Status }}</td>
                    <td class="p-3">{{ result.Condition }}</td>
                    <td class="p-3">{{ result.AssignedTo }}</td>
                    <td class="p-3">{{ result.Name }}</td>
                    <td class="p-3">{{ result.Description }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="errors" class="my-2">
              <div class="flex my-1">
                <p>Issues found ({{ errors.length }})</p>
              </div>
              <ul class="flex items-center gap-1">
                <img
                  class="h-5 object-contain p-1"
                  :src="create_success ? successImage : errorImage"
                />
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import axios from "axios";
// const pLimit = require("p-limit");
import { mapGetters } from "vuex";
import xlsx from "xlsx";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "AssetsBulkUpload",
  props: ["showAssetBulkUpload", "reload"],
  components: { Loader },
  data() {
    return {
      loading: false,
      ExcelFile: null,
      DataToUpload: null,
      RecordsFound: null,
      results: [],
      beganUploading: false,
      uploading: false,
      isDoneUploading: false,
      uploadLevel: 0,
      successImage: require("@/assets/icons/check.png"),
      errorImage: require("@/assets/icons/exclamation.png"),
      create_error: null,
      create_success: null,
      errors: null,
      uploadSucess: null,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    async onExcelFileChange() {
      try {
        this.ExcelFile = this.$refs.ExcelFile.files[0];
        const file = this.ExcelFile;
        const data = await file.arrayBuffer();

        const wb = xlsx.read(data);
        const sheet = wb.Sheets[wb.SheetNames[1]];
        const jsonSheet = xlsx.utils.sheet_to_json(sheet);

        this.DataToUpload = jsonSheet;
        this.RecordsFound = this.DataToUpload.length;
      } catch (error) {
        console.error("Error processing Excel file:", error);
        // Handle the error or log it as needed
      }
    },

    close() {
      this.$emit("close");
    },

    // /{organization}/employee/v1/bulkupload
    async create() {
      this.beganUploading = true;

      this.uploading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      // /{organization}/asset/bulk/v1/upload
      const request = axios.post(
        `${this.getOrganization}/asset/bulk/${this.$ApiVersion}/upload`,
        JSON.stringify({ Assets: this.DataToUpload }),
        options
      );
      return request
        .then((response) => {
          if (response.data.StatusCode == 200) {
            this.create_success = response.data.StatusMessage;
            this.uploading = false;
            this.isDoneUploading = true;
            this.reload();
            this.uploadSucess = true;
            setTimeout(() => {
              this.uploadSucess = null;
            }, 3000);
          } else {
            this.create_error = response.data.StatusMessage;
            this.uploading = false;
            this.isDoneUploading = true;
            this.errors = response.data.Errors;
            setTimeout(() => {
              this.create_error = null;
            }, 3000);
          }
        })
        .catch((e) => {
          this.create_error = e?.message;
          setTimeout(() => {
            this.create_error = null;
          }, 3000);
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.fade-in-enter-active {
  transition: all 0.5s ease;
}

.fade-in-leave-active {
  transition: all 0.5s ease;
}

.fade-in-enter,
.fade-in-leave-to {
  position: absolute;
  /* add for smooth transition between elements */
  opacity: 0;
}
</style>
